<div #filtersPanel id="filters-panel" class="tw-mb-5 tw-mt-6 tw-max-w-[95vw]">
  <!-- Mobile notice -->
  <div
    class="tw-block lg:tw-hidden tw-mb-4 tw-p-3 tw-bg-amber-50 dark:tw-bg-amber-900/20 tw-border tw-border-amber-200 dark:tw-border-amber-700 tw-rounded-lg">
    <div class="tw-flex tw-items-start tw-gap-2">
      <mat-icon
        class="tw-text-amber-600 dark:tw-text-amber-500 tw-text-xl tw-mt-0.5 tw-w-10 tw-h-10 "
        >info</mat-icon
      >
      <div class="tw-text-sm tw-text-amber-800 dark:tw-text-amber-200">
        <p class="tw-font-semibold tw-mb-1 tw-mt-2">This page is optimized for desktop use</p>
        <p class="tw-text-xs">
          For the best experience, we recommend using a larger screen to build and manage complex
          filter queries.
        </p>
      </div>
    </div>
  </div>

  <!-- filters tree expanded -->
  <div
    id="filters-expanded"
    *ngIf="showFilters"
    class="tw-overflow-x-auto tw-text-sm tw-text-gray-800 tw-bg-white dark:tw-bg-gray-700 tw-rounded tw-border tw-border-solid tw-border-gray-300 dark:tw-border-gray-600 tw-relative">
    <!-- Control row with QB info and action buttons -->
    <div
      *ngIf="hasFilters"
      class="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-px-4 tw-py-3 tw-bg-gray-50 dark:tw-bg-gray-800 tw-border-b tw-border-gray-200 dark:tw-border-gray-600 tw-flex-wrap">
      <!-- QB info display -->
      <div *ngIf="loadedQuickBuild" class="tw-flex tw-items-start tw-gap-3">
        <div class="tw-flex-1">
          <div class="tw-flex tw-items-center tw-gap-2 tw-mb-1">
            <span class="tw-text-xs tw-text-gray-600 dark:tw-text-gray-400">Quickbuild:</span>
            <span class="tw-font-semibold tw-text-gray-800 dark:tw-text-white">
              {{ loadedQuickBuild.name }}
            </span>
            <span
              *ngIf="loadedQuickBuild.category"
              class="tw-inline-flex tw-items-center tw-rounded-full tw-bg-primary_purple-100 dark:tw-bg-primary_purple-900 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-primary_purple-800 dark:tw-text-primary_purple-200">
              {{ loadedQuickBuild.category }}
            </span>
            <span
              *ngIf="loadedQuickBuild.scope === 'public'"
              class="tw-inline-flex tw-items-center tw-rounded-full tw-bg-blue-100 dark:tw-bg-blue-900 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-blue-800 dark:tw-text-blue-200">
              Public
            </span>
          </div>
          <p
            *ngIf="loadedQuickBuild.description"
            class="tw-text-xs tw-text-gray-600 dark:tw-text-gray-400 tw-mt-1">
            {{ loadedQuickBuild.description }}
          </p>
        </div>
        <button
          *ngIf="loadedQuickBuild.scope !== 'public' && !embedded"
          mat-icon-button
          (click)="editQuickBuildMetadata()"
          class="tw-text-gray-500 hover:tw-text-gray-700 dark:tw-text-gray-400 dark:hover:tw-text-gray-200 tw--mr-2"
          matTooltip="Edit quickbuild details">
          <mat-icon class="tw-text-[20px]">edit</mat-icon>
        </button>
      </div>

      <!-- Empty space when no quickbuild loaded -->
      <div *ngIf="!loadedQuickBuild" class="tw-flex-1"></div>

      <!-- Action buttons (hidden in embedded mode) -->
      <div *ngIf="!embedded" class="tw-flex tw-items-start tw-gap-2">
        <!-- Action buttons for desktop -->
        <div class="tw-hidden @mdx:tw-flex tw-items-center tw-gap-2">
          <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
        </div>

        <!-- Mobile buttons -->
        <ng-container *ngTemplateOutlet="mobileButtons"></ng-container>
      </div>
    </div>

    <!-- Main filter content area -->
    <div class="tw-p-4">
      <!-- Heading -->
      <h3
        *ngIf="hasFilters"
        class="tw-font-semibold tw-text-gray-800 dark:tw-text-white tw-mt-0 tw-mb-3">
        All matching people where:
      </h3>

      <div class="tw-w-full">
        <!-- Empty state with three clear sections in responsive layout -->
        <div *ngIf="!hasFilters" class="tw-flex tw-flex-col xxl:tw-flex-row tw-gap-6 tw-mb-6">
          <!-- Left Column - Quick Builds -->
          <div class="xxl:tw-flex-1 xxl:tw-min-w-0 xxl:tw-max-w-[820px]">
            <!-- Section 1: Quick Builds -->
            <div
              class="tw-p-6 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-rounded-lg dark:tw-bg-gray-600">
              <h4
                class="tw-text-lg tw-font-semibold tw-text-gray-800 dark:tw-text-white tw-mb-3 tw-mt-0">
                Quick Builds
              </h4>
              <p class="tw-text-gray-600 dark:tw-text-gray-300 tw-mb-0">
                Select an existing quick build as a starting point, containing pre-defined filters
                for various use cases.
              </p>
              <app-quickbuild-dropdown
                *ngIf="!palMode"
                [embedded]="true"
                (quickBuildSelected)="onQuickBuildSelected($event)">
              </app-quickbuild-dropdown>
            </div>
          </div>

          <!-- Right Column - Add Filters and AI Copilot -->
          <div class="tw-space-y-6 xxl:tw-flex-none xxl:tw-w-auto xxl:tw-min-w-[260px]">
            <!-- Section 2: Add Filters -->
            <div
              class="tw-p-6 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-rounded-lg dark:tw-bg-gray-600">
              <h4
                class="tw-text-lg tw-font-semibold tw-text-gray-800 dark:tw-text-white tw-mb-3 tw-mt-0">
                Add Filters
              </h4>
              <p class="tw-text-gray-600 dark:tw-text-gray-300 tw-mb-6">
                Build your search query by adding filters using boolean logic.
              </p>
              <div class="tw-flex tw-gap-3 tw-flex-wrap">
                <button
                  (click)="handleFilterAdded({component: null, isJobsGroup: false})"
                  class="tw-inline-flex tw-items-center tw-px-6 tw-py-3 tw-text-base tw-font-semibold tw-bg-teal-500 tw-text-white tw-ring-1 tw-ring-teal-500 hover:tw-bg-teal-600 tw-rounded tw-shadow-lg tw-transition-colors">
                  <mat-icon class="tw-text-[22px] tw-leading-6 tw-mr-2">add</mat-icon>
                  Add Filter
                </button>
                <button
                  (click)="addFilterGroup()"
                  class="tw-inline-flex tw-items-center tw-px-6 tw-py-3 tw-text-base tw-font-semibold tw-bg-teal-500 tw-text-white tw-ring-1 tw-ring-teal-500 hover:tw-bg-teal-600 tw-rounded tw-shadow-lg tw-transition-colors">
                  <mat-icon class="tw-text-[22px] tw-leading-6 tw-mr-2">playlist_add</mat-icon>
                  Add Filter Group
                </button>
              </div>
            </div>

            <!-- Section 3: AI Copilot -->
            <div
              *ngIf="!embedded && ((orgSettings | async)?.settings?.people?.features?.chat_to_query)"
              class="tw-p-6 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-rounded-lg dark:tw-bg-gray-600">
              <h4
                class="tw-text-lg tw-font-semibold tw-text-gray-800 dark:tw-text-white tw-mb-3 tw-mt-0">
                <span
                  class="tw-inline-flex tw-items-center tw-rounded-md tw-leading-4 tw-text-sm tw-font-semibold tw-text-blue-500 tw-ring-1 tw-ring-inset tw-ring-blue-500 tw-px-2 tw-py-1">
                  beta
                </span>
                AI Copilot
              </h4>
              <p class="tw-text-gray-600 dark:tw-text-gray-300 tw-mb-6">
                Use an AI copilot to help build your initial set of filters.
              </p>
              <app-people-chat-to-filters (quickBuild)="quickBuildFromChat($event)" [orgId]="orgId">
              </app-people-chat-to-filters>
            </div>
          </div>
        </div>

        <app-filter-group
          [group]="rootFilterGroup"
          [isRoot]="true"
          [depth]="0"
          (filterAdded)="handleFilterAdded($event)"
          (chartAdded)="handleChartAdded($event)"
          class="root-filter-group">
        </app-filter-group>
      </div>

      <div class="tw-flex tw-items-center tw-gap-2 tw-mt-4">
        <button
          mat-raised-button
          color="primary"
          class="tw-shrink-0"
          [class.spinner]="refreshing"
          [disabled]="refreshing || !hasFilters"
          [matTooltip]="!hasFilters ? 'Add filters to search' : ''"
          matTooltipPosition="above"
          (click)="runSearch()">
          Search
        </button>
        <button
          *ngIf="!embedded"
          mat-stroked-button
          color="primary"
          class="tw-shrink-0"
          [disabled]="!hasFilters"
          [matTooltip]="!hasFilters ? 'Add filters to get the API request' : ''"
          (click)="copyFiltersToClipboard()">
          Copy API Request
        </button>
      </div>
    </div>
  </div>

  <!-- Collapsed view: Show quickbuild bar or filter chips -->
  <div
    *ngIf="!showFilters && loadedQuickBuild && hasFilters"
    class="tw-overflow-x-auto tw-text-sm tw-text-gray-800 tw-bg-white dark:tw-bg-gray-700 tw-rounded tw-border tw-border-solid tw-border-gray-300 dark:tw-border-gray-600">
    <div
      class="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-px-4 tw-py-3 tw-bg-gray-50 dark:tw-bg-gray-800 tw-flex-wrap">
      <!-- QB info display -->
      <div class="tw-flex tw-items-start tw-gap-3">
        <div class="tw-flex-1">
          <div class="tw-flex tw-items-center tw-gap-2 tw-mb-1">
            <span class="tw-text-xs tw-text-gray-600 dark:tw-text-gray-400">Quickbuild:</span>
            <span class="tw-font-semibold tw-text-gray-800 dark:tw-text-white">
              {{ loadedQuickBuild.name }}
            </span>
            <span
              *ngIf="loadedQuickBuild.category"
              class="tw-inline-flex tw-items-center tw-rounded-full tw-bg-primary_purple-100 dark:tw-bg-primary_purple-900 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-primary_purple-800 dark:tw-text-primary_purple-200">
              {{ loadedQuickBuild.category }}
            </span>
            <span
              *ngIf="loadedQuickBuild.scope === 'public'"
              class="tw-inline-flex tw-items-center tw-rounded-full tw-bg-blue-100 dark:tw-bg-blue-900 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-blue-800 dark:tw-text-blue-200">
              Public
            </span>
          </div>
          <p
            *ngIf="loadedQuickBuild.description"
            class="tw-text-xs tw-text-gray-600 dark:tw-text-gray-400 tw-mt-1">
            {{ loadedQuickBuild.description }}
          </p>
        </div>
        <button
          *ngIf="loadedQuickBuild.scope !== 'public' && !embedded"
          mat-icon-button
          (click)="editQuickBuildMetadata()"
          class="tw-text-gray-500 hover:tw-text-gray-700 dark:tw-text-gray-400 dark:hover:tw-text-gray-200 tw--mr-2"
          matTooltip="Edit quickbuild details">
          <mat-icon class="tw-text-[20px]">edit</mat-icon>
        </button>
      </div>

      <!-- Action buttons (hidden in embedded mode) -->
      <div *ngIf="!embedded" class="tw-flex tw-items-start tw-gap-2">
        <!-- Action buttons for desktop -->
        <div class="tw-hidden @mdx:tw-flex tw-items-center tw-gap-2">
          <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
        </div>

        <!-- Mobile buttons -->
        <ng-container *ngTemplateOutlet="mobileButtons"></ng-container>
      </div>
    </div>
  </div>

  <!-- Shared mobile buttons template -->
  <ng-template #mobileButtons>
    <!-- Action buttons for mobile -->
    <button
      [matMenuTriggerFor]="mobileMenu"
      class="@mdx:tw-hidden tw-p-2 tw-rounded-full tw-text-gray-100 tw-transition-colors tw-bg-gray-700 hover:tw-bg-gray-600">
      <mat-icon class="tw-align-middle">more_vert</mat-icon>
    </button>

    <!-- Action buttons dropdown menu for mobile -->
    <mat-menu #mobileMenu="matMenu">
      <button
        mat-menu-item
        *ngIf="loadedQuickBuild && (loadedQuickBuild.scope !== 'public' || (isEmployee$ | async))"
        (click)="saveExistingQuickBuild()">
        <mat-icon>save</mat-icon>
        <span>Save Changes</span>
      </button>

      <button
        mat-menu-item
        *ngIf="rootFilterGroup.filters.length > 0"
        (click)="showAddQuickBuildDialog()">
        <mat-icon>add</mat-icon>
        <span>Save as New Quick Build</span>
      </button>

      <button mat-menu-item [matMenuTriggerFor]="quickBuildMenu">
        <mat-icon>folder_open</mat-icon>
        <span>Load Quick Build</span>
      </button>
    </mat-menu>

    <button
      *ngIf="rootFilterGroup.filters.length > 0"
      (click)="deleteAllFilters()"
      class="@md:tw-hidden tw-p-2 tw-rounded-full tw-text-red-400 tw-transition-colors tw-bg-gray-700 hover:tw-bg-gray-600">
      <mat-icon class="tw-align-middle">delete_outline</mat-icon>
    </button>
  </ng-template>

  <!-- Shared action buttons template -->
  <ng-template #actionButtons>
    <!-- Admin button moved to left -->
    <button
      *ngIf="isEmployee$ | async"
      mat-icon-button
      [matMenuTriggerFor]="menu"
      aria-label="open more actions"
      class="small-icon-button tw-inline-flex tw-w-auto tw-h-auto tw-text-gray-800 tw-rounded-md tw-border tw-border-solid tw-border-gray-300 tw-leading-8 focus:tw-bg-gray-100 hover:tw-bg-gray-100 dark:focus:tw-bg-gray-900 dark:hover:tw-bg-gray-900 tw-transition-all dark:tw-text-white dark:tw-border-gray-500 tw-px-4">
      <mat-icon>construction</mat-icon>
    </button>

    <!-- Save as New Quick Build -->
    <button
      *ngIf="rootFilterGroup.filters.length > 0"
      mat-stroked-button
      color="primary"
      (click)="showAddQuickBuildDialog()"
      class="tw-bg-teal-500/25">
      <span class="tw-flex tw-items-center tw-gap-2">
        <mat-icon class="tw-text-base tw-w-[18px]">add</mat-icon>
        Save as New Quick Build
      </span>
    </button>

    <!-- Save Changes button for modified loaded quickbuilds -->
    <button
      *ngIf="loadedQuickBuild && (loadedQuickBuild.scope !== 'public' || (isEmployee$ | async))"
      mat-stroked-button
      color="primary"
      (click)="saveExistingQuickBuild()"
      class="tw-bg-teal-500/25">
      <span class="tw-flex tw-items-center tw-gap-2">
        <mat-icon class="tw-text-base tw-w-[18px]">save</mat-icon>
        Save Changes
      </span>
    </button>

    <button
      mat-stroked-button
      color="primary"
      [matMenuTriggerFor]="quickBuildMenu"
      #quickBuildMenuTrigger="matMenuTrigger">
      <span class="tw-flex tw-items-center tw-gap-2">
        <mat-icon class="tw-text-base tw-w-[18px]">folder_open</mat-icon>
        Load Quick Build
      </span>
    </button>

    <button
      mat-stroked-button
      color="warn"
      *ngIf="rootFilterGroup.filters.length > 0"
      (click)="deleteAllFilters()">
      <span class="tw-flex tw-items-center tw-gap-2 tw-text-red-400">
        <mat-icon class="tw-text-base tw-w-[18px]">delete_outline</mat-icon>
        Clear Filters
      </span>
    </button>
  </ng-template>

  <!-- Shared menus for both expanded and collapsed views -->
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="copyQuickBuildToClipboard()">
      <mat-icon>content_copy</mat-icon>
      <span>Copy QB to Clipboard</span>
    </button>
    <button mat-menu-item (click)="importQBFromClipboard()">
      <mat-icon>content_paste</mat-icon>
      <span>Import QB from Clipboard</span>
    </button>
  </mat-menu>

  <!-- QuickBuild Menu -->
  <mat-menu
    #quickBuildMenu="matMenu"
    class="quickbuild-dropdown-menu-panel"
    backdropClass="darker-dialog-backdrop">
    <app-quickbuild-dropdown *ngIf="!palMode" (quickBuildSelected)="onQuickBuildSelected($event)">
    </app-quickbuild-dropdown>
  </mat-menu>

  <!-- filter chips (show in collapsed mode when no quickbuild or no filters) -->
  <app-filter-chips
    *ngIf="(!loadedQuickBuild && !showFilters) || (!hasFilters && !showFilters) || showFilters"
    [rootFilterGroup]="rootFilterGroup"
    [showFilters]="showFilters"
    [categories]="categories"
    (filterAdded)="handleFilterAdded($event)"
    (filterRemoved)="removeFilterChip($event)">
  </app-filter-chips>

  <div
    id="filters-toggle-container"
    class="tw-w-100 tw-flex tw-justify-center"
    [ngClass]="{ 'tw-mt-[-16px]': showFilters, 'tw-mt-[-8px]': !showFilters }">
    <!-- Regular toggle buttons when not embedded -->
    <ng-container *ngIf="!embedded">
      <button
        *ngIf="showFilters"
        mat-stroked-button
        color="primary"
        class="tw-bg-white dark:tw-bg-gray-800 dark:tw-text-teal-400"
        matTooltipPosition="right"
        (click)="toggleFiltersContent()">
        <mat-icon class="tw-font-bold">keyboard_arrow_up</mat-icon>
      </button>
      <button
        *ngIf="!showFilters"
        color="primary"
        class="tw-text-sm tw-flex tw-items-center tw-text-primary_purple-600 tw-border tw-border-solid tw-border-gray-300 dark:tw-border-gray-700 tw-rounded tw-bg-white dark:tw-bg-gray-800 dark:tw-text-teal-400 focus:tw-bg-slate-100 focus:tw-border-2"
        matTooltipPosition="right"
        (click)="toggleFiltersContent()">
        <mat-icon class="tw-font-bold tw-leading-6">keyboard_arrow_down</mat-icon>
        Show/Edit Filters
      </button>
    </ng-container>

    <!-- Open in Advanced Editor button when embedded -->
    <button
      *ngIf="embedded && !showFilters"
      mat-stroked-button
      color="primary"
      class="tw-bg-white dark:tw-bg-gray-800 dark:tw-text-teal-400 tw-text-sm tw-flex tw-items-center tw-gap-1"
      (click)="openInAdvancedEditor()">
      <mat-icon class="tw-text-base">open_in_new</mat-icon>
      Open in Advanced Editor
    </button>
  </div>
</div>

<div class="tw-flex tw-flex-wrap tw-gap-3 tw-items-center tw-my-5">
  <button
    *ngIf="!embedded"
    mat-stroked-button
    color="primary"
    class="tw-shrink-0"
    [class.spinner]="downloading"
    [disabled]="downloading || !searchCount || searchCount === 0"
    (click)="download()">
    Download
  </button>
</div>

<div class="tw-relative">
  <!-- table -->
  <div class="tw-flex tw-flex-row tw-gap-2 tw-w-full tw-mt-7 tw-flex-wrap">
    <h3
      *ngIf="searchCount > 50"
      class="tw-mb-2 tw-font-semibold tw-text-gray-800 dark:tw-text-gray-200">
      Sample of <span class="tw-font-bold">50</span> matching people
    </h3>
    <div
      id="people-grid"
      class="tw-flex tw-flex-col tw-gap-2 tw-w-full tw-h-[calc(100vh-160px)]"
      tourAnchor="people-grid">
      <div *ngIf="peopleGridType === 'sample'" class="tw-mb-4">
        <app-alert
          [alertType]="AlertType.Info"
          [alertStyle]="'compact'"
          [hasBorder]="false"
          [noBottomMargin]="true">
          <p class="tw-my-2">
            Preview data below includes limited columns and rows. Download the data for the full
            dataset.
          </p>
        </app-alert>
      </div>
      <ag-grid-angular
        id="people-grid-ag-grid"
        style="height: 100%; width: 100%"
        [ngClass]="{ 'ag-theme-quartz': !(darkModeService.darkMode$ | async), 'ag-theme-quartz-dark': darkModeService.darkMode$ | async }"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        suppressContextMenu="true"
        [defaultColDef]="defaultColDef"
        (gridReady)="onGridReady($event)"
        (rowClicked)="onPersonRowClicked($event)">
      </ag-grid-angular>
    </div>
  </div>
  <div
    class="tw-absolute tw-top-0 md:tw-top-10 md:tw-right-4 tw-transform tw--translate-y-1/2 tw-text-sm tw-text-gray-800 dark:tw-text-gray-200 tw-pointer-events-none">
    <div class="count tw-flex tw-items-center tw-ml-0 xl:tw-ml-4">
      <mat-progress-spinner
        mode="indeterminate"
        class="tw-mr-3"
        diameter="20"
        *ngIf="countUpdating; else contactCount">
      </mat-progress-spinner>
      <ng-template #contactCount>
        <span class="tw-font-semibold tw-mr-2 tw-rounded">{{searchCount | number}}</span>
      </ng-template>
      Matching People
    </div>
  </div>
</div>
